export default "/images/mpg_logo.svg?a0bec1f1f134fd9e3f6383c2bb0719e5";